import SaveIcon from '@mui/icons-material/Save';
import {
  Button,
  CircularProgress,
  Grid,
  IconButton,
  Paper,
  Typography,
  Box,
} from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect, useDispatch } from 'react-redux';
import { ErrorAlert } from '../../components/atoms/Alert-message';
import CustomSelect from '../../components/atoms/custom-select';
import InputTextField from '../../components/atoms/input-field/inputTextField';
import { APIHeader } from '../../index';
import { errorNotification } from '../../reducers/handle-api-status/slice';
import PageHeader from '../../components/shared/PageHeader';
import {
  ListFilterTableGrid,
  TrackingInfoDrivers,
  homeButtonComponent,
  titleName,
  SaveIconStyle,
  pointerCursor,
  SavedViewStyle,
  pageGrid,
  modernContentSection,
} from '../../styles';
import { isEmptyObject, stripTrailingSlash } from '../../utils';
import MySavedViewModal from '../MySavedViewModal';
import AddEditUserModal from './AddEditUserModal';
import Filter from './Filter';
import UMTable from './UMTable';

const UserManagement = props => {
  const { apiConfig, userInfo, errorInAPI } = props;
  const { t } = useTranslation();
  const bookmarkRef = useRef(false);
  const dispatch = useDispatch();

  const originURL = window.location.origin.toString();
  const filterId = stripTrailingSlash(window.location.toString())
    .split('/')
    .pop();

  const [isLoading, setIsLoading] = useState(true);
  const [showTable, setShowTable] = useState(true);
  const [userList, setUserList] = useState([]);
  const [searchString, setSearchString] = useState('');
  const [siteListData, setSiteListData] = useState([]);
  const [departmentListData, setDepartmentListData] = useState([]);
  const [selectedUserFilter, setSelectedUserFilter] = useState({
    ID: -1,
    SortBy: 'UserId',
    OrderBy: 'desc',
    DepartmentsFilter: '',
    SitesFilter: '',
    FilterName: '',
    UserID: -1,
    ActiveFilter: '',
  });
  const [filterSiteData, setFilterSiteData] = useState([]);
  const [filterDepartmentData, setFilterDepartmentData] = useState([]);
  const [filterActiveData, setFilterActiveData] = useState([]);
  const [getAllFilters, setGetAllFilters] = useState([]);
  const [openSaveModal, setOpenSaveModal] = useState(false);
  const [filterName, setFilterName] = useState('');
  const [errorMessage, setErrorMessage] = useState(null);
  const [isAddUserOpen, setIsAddUserOpen] = useState(false);
  const [isEditUserOpen, setIsEditUserOpen] = useState(false);
  const [userDataForEdit, setUserDataForEdit] = useState({});
  const [allusersEmail, setAllusersEmail] = useState([]);
  const activeArray = [
    {
      value: '1',
      checked: true,
      label: t('Yes'),
    },
    {
      value: '0',
      checked: false,
      label: t('No'),
    },
  ];

  //To load the page with bookmarked filter
  useEffect(() => {
    if (
      bookmarkRef.current ||
      filterId === 'UM' ||
      getAllFilters.length === 0 ||
      departmentListData.length === 0 ||
      siteListData.length === 0
    ) {
      return;
    }
    bookmarkRef.current = true;
    setIsLoading(true);
    const findFilter = getAllFilters.find(list => {
      return filterId.toString() === list.ID.toString();
    });
    setSelectedUserFilter(findFilter);

    if (findFilter) {
      const findDepartmentFiltered = findFilter.DepartmentsFilter.split(',');
      const findSiteFiltered = findFilter.SitesFilter.split(',');
      const findActiveFiltered = findFilter.ActiveFilter.split(',');

      // Get the List of Users based on selected filter
      fetch(`${apiConfig.uiURL}api/FetchUserManagementDetails`, {
        method: 'POST',
        headers: APIHeader(),
        body: JSON.stringify({
          sort: findFilter.SortBy,
          ascdesc: findFilter.OrderBy,
          filterSites: findFilter.SitesFilter,
          filterDepartment: findFilter.DepartmentsFilter,
          filterActive: findFilter.ActiveFilter,
        }),
      })
        .then(async response => {
          const data = await response.json();
          setUserList(data);
          const departmentFiltered = departmentListData.map(item => {
            if (findDepartmentFiltered.includes(item.Name)) {
              return { ...item, checked: true };
            } else {
              return { ...item, checked: false };
            }
          });
          setFilterDepartmentData(departmentFiltered);

          const siteFiltered = siteListData.map(item => {
            if (findSiteFiltered.includes(item.SiteName)) {
              return { ...item, checked: true };
            } else {
              return { ...item, checked: false };
            }
          });
          setFilterSiteData(siteFiltered);

          const activeFiltered = activeArray.map(item => {
            if (findActiveFiltered.includes(item.value)) {
              return { ...item, checked: true };
            } else {
              return { ...item, checked: false };
            }
          });
          setFilterActiveData(activeFiltered);
          setIsLoading(false);
        })
        .catch(() => {
          dispatch(
            errorNotification({
              hasErrorOccured: true,
              message: t('error_message'),
            })
          );
        });
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getAllFilters, filterId, siteListData, departmentListData, apiConfig]);

  useEffect(() => {
    //Get the site list
    fetch(`${apiConfig.uiURL}api/SiteList`, {
      headers: APIHeader(),
    })
      .then(async response => {
        const siteData = await response.json();
        setSiteListData(siteData);
        //map site data and set checked as true
        const filterData =
          siteData &&
          siteData.length > 0 &&
          siteData.map(siteList => {
            return {
              ...siteList,
              checked: true,
            };
          });
        setFilterSiteData(filterData);
      })
      .catch(() => {
        dispatch(
          errorNotification({
            hasErrorOccured: true,
            message: t('error_message'),
          })
        );
      });
    //Get the department list
    fetch(`${apiConfig.uiURL}api/FetchPECRDepartments`, {
      headers: APIHeader(),
    })
      .then(async response => {
        const departmentData = await response.json();
        setDepartmentListData(departmentData);
        //map department data and set checked as true
        const filterData =
          departmentData &&
          departmentData.length > 0 &&
          departmentData.map(departmentList => {
            return {
              ...departmentList,
              checked: true,
            };
          });
        setFilterDepartmentData(filterData);
      })
      .catch(() => {
        dispatch(
          errorNotification({
            hasErrorOccured: true,
            message: t('error_message'),
          })
        );
      });
    //Get the All user's email list
    fetch(`${apiConfig.uiURL}api/FetchAllUserEmail`, {
      headers: APIHeader(),
    })
      .then(async response => {
        const emailData = await response.json();
        setAllusersEmail(emailData);
      })
      .catch(() => {
        dispatch(
          errorNotification({
            hasErrorOccured: true,
            message: t('error_message'),
          })
        );
      });
    //set activeArray as filterActiveData
    setFilterActiveData(activeArray);
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apiConfig]);

  //useEffect is getting exceuted for default page
  useEffect(() => {
    if (
      filterDepartmentData.length > 0 &&
      filterSiteData.length > 0 &&
      filterActiveData.length > 0 &&
      filterId === 'UM'
    ) {
      setIsLoading(true);
      const filterDept = filterDepartmentData
        .filter(item => item.checked)
        .map(item => item.Name)
        .toString();
      const filterSite = filterSiteData
        .filter(item => item.checked)
        .map(item => item.SiteName)
        .toString();
      const filterActive = filterActiveData
        .filter(item => item.checked)
        .map(item => item.value)
        .toString();

      //fetch userList to show by default
      fetch(`${apiConfig.uiURL}api/FetchUserManagementDetails`, {
        method: 'POST',
        headers: APIHeader(),
        body: JSON.stringify({
          search: searchString,
          sort: selectedUserFilter.SortBy,
          ascdesc: selectedUserFilter.OrderBy,
          filterDepartment: filterDept,
          filterSites: filterSite,
          filterActive: filterActive,
        }),
      })
        .then(async response => {
          const data = await response.json();
          setUserList(data);
          setIsLoading(false);
        })
        .catch(() => {
          dispatch(
            errorNotification({
              hasErrorOccured: true,
              message: t('error_message'),
            })
          );
        });
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    filterDepartmentData,
    filterSiteData,
    filterActiveData,
    apiConfig,
    filterId,
  ]);
  useEffect(() => {
    if (userInfo && userInfo.userID) {
      //fetch all saved filters based on userID
      fetch(`${apiConfig.uiURL}api/FetchPECRUsersFilter`, {
        method: 'POST',
        headers: APIHeader(),
        body: JSON.stringify({
          UserId: userInfo.userID,
        }),
      })
        .then(async response => {
          const data = await response.json();
          setGetAllFilters(data);
        })
        .catch(() => {
          dispatch(
            errorNotification({
              hasErrorOccured: true,
              message: t('error_message'),
            })
          );
        });
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfo, userInfo.userID, apiConfig]);

  //To replace the URL with originURL and the selected filterId
  const replaceURL = value => {
    const finalURL = `${originURL}/UM/${value}`;
    window.history.replaceState(null, null, finalURL);
  };

  //options for My Save View drop-down
  const saveViewOptions =
    getAllFilters.length > 0
      ? getAllFilters.map(list => {
          return {
            label: list.FilterName,
            value: list.ID,
          };
        })
      : [];

  //to get the value for My Saved View drop down
  const valueAfterFilterSelection =
    saveViewOptions.length > 0 &&
    selectedUserFilter &&
    !isEmptyObject(selectedUserFilter) &&
    selectedUserFilter.ID !== -1 &&
    saveViewOptions.filter(
      ({ value }) => selectedUserFilter.ID.toString() === value.toString()
    );

  //To handle the onChange event of search box
  const handleSearchChange = event => {
    setShowTable(false);
    const searchText = event.target.value.trim();
    setSearchString(searchText);
    // Get the List of Users based on search
    fetch(`${apiConfig.uiURL}api/FetchUserManagementDetails`, {
      method: 'POST',
      headers: APIHeader(),
      body: JSON.stringify({
        search: searchText,
        sort: selectedUserFilter.SortBy,
        ascdesc: selectedUserFilter.OrderBy,
        filterDepartment: selectedUserFilter.DepartmentsFilter,
        filterSites: selectedUserFilter.SitesFilter,
        filterActive: selectedUserFilter.ActiveFilter,
      }),
    })
      .then(async response => {
        const data = await response.json();
        setUserList(data);
        setShowTable(true);
      })
      .catch(() => {
        dispatch(
          errorNotification({
            hasErrorOccured: true,
            message: t('error_message'),
          })
        );
      });
  };

  //To handle the sorting of columns in UM table
  const handleOrderChange = (columnId, order) => {
    setShowTable(false);
    setSelectedUserFilter({
      ...selectedUserFilter,
      SortBy: columnId,
      OrderBy: order,
    });
    // Get the List of Users based on sorted column and order
    fetch(`${apiConfig.uiURL}api/FetchUserManagementDetails`, {
      method: 'POST',
      headers: APIHeader(),
      body: JSON.stringify({
        search: searchString,
        sort: columnId,
        ascdesc: order,
        filterDepartment: selectedUserFilter.DepartmentsFilter,
        filterSites: selectedUserFilter.SitesFilter,
        filterActive: selectedUserFilter.ActiveFilter,
      }),
    })
      .then(async response => {
        const data = await response.json();
        setUserList(data);
        setShowTable(true);
      })
      .catch(() => {
        dispatch(
          errorNotification({
            hasErrorOccured: true,
            message: t('error_message'),
          })
        );
      });
  };

  //To handle the refresh button of Filter
  const onRefreshClick = filteredData => {
    setShowTable(false);
    setSelectedUserFilter({
      ...selectedUserFilter,
      DepartmentsFilter: filteredData.selectedDepartment,
      SitesFilter: filteredData.selectedSites,
      ActiveFilter: filteredData.selectedActive,
    });
    // Get the List of Users based on selected filters
    fetch(`${apiConfig.uiURL}api/FetchUserManagementDetails`, {
      method: 'POST',
      headers: APIHeader(),
      body: JSON.stringify({
        search: searchString,
        sort: selectedUserFilter.SortBy,
        ascdesc: selectedUserFilter.OrderBy,
        filterDepartment: filteredData.selectedDepartment,
        filterSites: filteredData.selectedSites,
        filterActive: filteredData.selectedActive,
      }),
    })
      .then(async response => {
        const data = await response.json();
        setUserList(data);
        setShowTable(true);
      })
      .catch(() => {
        dispatch(
          errorNotification({
            hasErrorOccured: true,
            message: t('error_message'),
          })
        );
      });
  };
  //handle onchange event of My saved view drop-down
  const handleSavedViewChange = event => {
    setShowTable(false);
    const findFilter = getAllFilters.find(list => {
      return event.value === list.ID;
    });
    setSelectedUserFilter(findFilter);
    const findDepartmentFiltered = findFilter.DepartmentsFilter.split(',');
    const findSiteFiltered = findFilter.SitesFilter.split(',');
    const findActiveFiltered = findFilter.ActiveFilter.split(',');

    // Get the List of Users based on selected filter
    fetch(`${apiConfig.uiURL}api/FetchUserManagementDetails`, {
      method: 'POST',
      headers: APIHeader(),
      body: JSON.stringify({
        search: searchString,
        sort: findFilter.SortBy,
        ascdesc: findFilter.OrderBy,
        filterDepartment: findFilter.DepartmentsFilter,
        filterSites: findFilter.SitesFilter,
        filterActive: findFilter.ActiveFilter,
      }),
    })
      .then(async response => {
        const data = await response.json();
        setUserList(data);
        const departmentFiltered = departmentListData.map(item => {
          if (findDepartmentFiltered.includes(item.Name)) {
            return { ...item, checked: true };
          } else {
            return { ...item, checked: false };
          }
        });
        setFilterDepartmentData(departmentFiltered);

        const siteFiltered = siteListData.map(item => {
          if (findSiteFiltered.includes(item.SiteName)) {
            return { ...item, checked: true };
          } else {
            return { ...item, checked: false };
          }
        });
        setFilterSiteData(siteFiltered);

        const activeFiltered = activeArray.map(item => {
          if (findActiveFiltered.includes(item.value)) {
            return { ...item, checked: true };
          } else {
            return { ...item, checked: false };
          }
        });
        setFilterActiveData(activeFiltered);
        setShowTable(true);
        replaceURL(event.value);
      })
      .catch(() => {
        dispatch(
          errorNotification({
            hasErrorOccured: true,
            message: t('error_message'),
          })
        );
      });
  };
  //To handle the onclick event of Save icon
  const onSaveIconClick = () => {
    setOpenSaveModal(true);
  };

  //To handle the Save click of Saved View Name Modal
  const onSaveModalClick = () => {
    setErrorMessage(null);
    if (userInfo && userInfo.userID && userInfo.userID !== '') {
      //Call InsertUpdateUsersFilter API to create new filter with new name and other selected parameters
      fetch(`${apiConfig.uiURL}api/InsertUpdateUsersFilter`, {
        method: 'POST',
        headers: APIHeader(),
        body: JSON.stringify({
          FilterId: null,
          UserID: userInfo.userID,
          SortBy:
            selectedUserFilter && selectedUserFilter.SortBy
              ? selectedUserFilter.SortBy
              : 'UserId',
          OrderBy:
            selectedUserFilter && selectedUserFilter.OrderBy
              ? selectedUserFilter.OrderBy
              : 'desc',
          DepartmentFilter: selectedUserFilter.DepartmentsFilter,
          SiteFilter: selectedUserFilter.SitesFilter,
          ActiveFilter: selectedUserFilter.ActiveFilter,
          FilterName: filterName,
        }),
      })
        .then(async response => {
          const insertedFilterId = await response.json();
          //To close the Saved View Name Modal
          setOpenSaveModal(false);

          if (userInfo && userInfo.userID) {
            //fetch all saved filters based on userID
            fetch(`${apiConfig.uiURL}api/FetchPECRUsersFilter`, {
              method: 'POST',
              headers: APIHeader(),
              body: JSON.stringify({
                UserId: userInfo.userID,
              }),
            })
              .then(async response => {
                const data = await response.json();
                setGetAllFilters(data);
                //find selected filter based on last inserted Id/filter
                const findSelectedFilter = data.find(item => {
                  return (
                    item.ID.toString() === insertedFilterId.insertId.toString()
                  );
                });
                setSelectedUserFilter(findSelectedFilter);
                // setIsRefreshClicked(false);
                replaceURL(insertedFilterId.insertId);
              })
              .catch(() => {
                dispatch(
                  errorNotification({
                    hasErrorOccured: true,
                    message: t('error_message'),
                  })
                );
              });
          }
        })
        .catch(() => {
          dispatch(
            errorNotification({
              hasErrorOccured: true,
              message: t('error_message'),
            })
          );
        });
    }
  };

  //To handle the close/cancel click of saved view Name Modal
  const onCloseModalClick = () => {
    setOpenSaveModal(false);
    setErrorMessage(null);
  };

  //To open the Add User Modal on Click of "Add User" button
  const openAddUserClick = () => {
    setIsAddUserOpen(true);
  };

  //To handle the close/cancel click of Add user Modal
  const onAddUserCloseClick = () => {
    setIsAddUserOpen(false);
  };

  //To handle the Save click of Add user Modal
  const onAddUserSaveClick = userData => {
    setIsAddUserOpen(false);
    setShowTable(false);
    //To add new User in User table
    fetch(`${apiConfig.uiURL}api/InsertUpdateUsersFromUM`, {
      method: 'POST',
      headers: APIHeader(),
      body: JSON.stringify({
        UserId: null,
        FirstName: userData.FirstName,
        LastName: userData.LastName,
        Email: userData.Email,
        SiteID: userData.SiteID,
        DepartmentID: userData.DepartmentID,
        DepartmentLead: userData.DepartmentLead ? '1' : '0',
      }),
    })
      .then(async response => {
        // Get the List of Users based on selected filter
        fetch(`${apiConfig.uiURL}api/FetchUserManagementDetails`, {
          method: 'POST',
          headers: APIHeader(),
          body: JSON.stringify({
            search: searchString,
            sort: selectedUserFilter.SortBy,
            ascdesc: selectedUserFilter.OrderBy,
            filterDepartment: selectedUserFilter.DepartmentsFilter,
            filterSites: selectedUserFilter.SitesFilter,
            filterActive: selectedUserFilter.ActiveFilter,
          }),
        })
          .then(async response => {
            const data = await response.json();
            setUserList(data);
            setShowTable(true);
          })
          .catch(() => {
            dispatch(
              errorNotification({
                hasErrorOccured: true,
                message: t('error_message'),
              })
            );
          });
      })
      .catch(() => {
        dispatch(
          errorNotification({
            hasErrorOccured: true,
            message: t('error_message'),
          })
        );
      });
  };

  //To open the Edit User Modal on Click of the User name in table
  const openEditUserClick = userId => {
    setIsEditUserOpen(true);
    //Fetch Users based on User Id to Edit
    fetch(`${apiConfig.uiURL}api/FetchUserBasedOnID`, {
      method: 'POST',
      headers: APIHeader(),
      body: JSON.stringify({
        UserId: userId,
      }),
    })
      .then(async response => {
        const data = await response.json();
        setUserDataForEdit(data[0]);
      })
      .catch(() => {
        dispatch(
          errorNotification({
            hasErrorOccured: true,
            message: t('error_message'),
          })
        );
      });
  };

  //To handle the close/cancel click of Edit user Modal
  const onEditUserCloseClick = () => {
    setIsEditUserOpen(false);
    setUserDataForEdit({});
  };
  //To handle the Save click of Edit user Modal
  const onEditUserSaveClick = userData => {
    setIsEditUserOpen(false);
    setUserDataForEdit({});
    setShowTable(false);
    fetch(`${apiConfig.uiURL}api/InsertUpdateUsersFromUM`, {
      headers: APIHeader(),
      method: 'PUT',
      body: JSON.stringify({
        UserId: userData.UserId,
        FirstName: userData.FirstName,
        LastName: userData.LastName,
        Email: userData.Email,
        SiteID: userData.SiteID,
        DepartmentID: userData.DepartmentID,
        DepartmentLead: userData.DepartmentLead ? '1' : '0',
        IsActive: userData.Active ? '1' : '0',
      }),
    })
      .then(async response => {
        // Get the List of Users based on selected filter
        fetch(`${apiConfig.uiURL}api/FetchUserManagementDetails`, {
          method: 'POST',
          headers: APIHeader(),
          body: JSON.stringify({
            search: searchString,
            sort: selectedUserFilter.SortBy,
            ascdesc: selectedUserFilter.OrderBy,
            filterDepartment: selectedUserFilter.DepartmentsFilter,
            filterSites: selectedUserFilter.SitesFilter,
            filterActive: selectedUserFilter.ActiveFilter,
          }),
        })
          .then(async response => {
            const data = await response.json();
            setUserList(data);
            setShowTable(true);
          })
          .catch(() => {
            dispatch(
              errorNotification({
                hasErrorOccured: true,
                message: t('error_message'),
              })
            );
          });
      })
      .catch(() => {
        dispatch(
          errorNotification({
            hasErrorOccured: true,
            message: t('error_message'),
          })
        );
      });
  };

  if (errorInAPI.hasErrorOccured) {
    return <ErrorAlert message={errorInAPI.message} />;
  }

  if ((userInfo && userInfo.userId === '') || isLoading) {
    return (
      <Grid style={homeButtonComponent}>
        <CircularProgress />
      </Grid>
    );
  }

  if (
    userInfo &&
    userInfo?.role !== 'Site Administrator' &&
    userInfo?.role !== 'System Administrator'
    // ******* DELETE THIS, ONLY HERE FOR TESTINGG*****
    // userInfo?.role !== "Site Coordinator"
  ) {
    return (
      <Grid style={homeButtonComponent}>{t('No_active_user_message')}</Grid>
    );
  }
  if (
    (userInfo && userInfo?.active?.toString() === '0') ||
    userInfo?.userId.toString() === '0' ||
    userInfo?.userId === null
  ) {
    return (
      <Grid style={homeButtonComponent}>{t('No_active_user_message')}</Grid>
    );
  }
  return (
    <div className="flex flex-col">
      <PageHeader title={t('User_Management')}>
        <Button
          sx={{
            textTransform: 'none',
            fontSize: '16px',
            backgroundColor: 'rgba(255, 255, 255, 0.2)',
            '&:hover': {
              backgroundColor: 'rgba(255, 255, 255, 0.3)',
            },
            backdropFilter: 'blur(10px)',
            border: '1px solid rgba(255, 255, 255, 0.3)',
            color: 'white',
          }}
          onClick={openAddUserClick}
        >
          {`+ ${t('Add_User')}`}
        </Button>
      </PageHeader>
      <Box style={modernContentSection}>
        <Grid style={ListFilterTableGrid}>
          <Grid>
            <Paper width={'300px'}>
              <InputTextField
                name={'SearchBox'}
                placeholder={`${t('Search')}...`}
                style={{
                  padding: '10px',
                  marginBottom: '10px',
                }}
                onChange={event => handleSearchChange(event)}
              />
            </Paper>
            <Paper
              component={'div'}
              style={{
                marginBottom: '10px',
                display: 'flex',
                justifyContent: 'space-between',
                border: '1px solid rgba(224, 224, 224, 1)',
              }}
            >
              <Grid>
                <CustomSelect
                  name={'mySavedViews'}
                  id={'mySavedViews'}
                  placeholder={t('My_Saved_Views')}
                  options={saveViewOptions}
                  styles={SavedViewStyle}
                  onChange={handleSavedViewChange}
                  value={
                    valueAfterFilterSelection &&
                    valueAfterFilterSelection.length > 0 &&
                    valueAfterFilterSelection
                  }
                />
              </Grid>
              <Grid style={SaveIconStyle}>
                <IconButton onClick={onSaveIconClick}>
                  <SaveIcon
                    color="primary"
                    fontSize="large"
                    style={pointerCursor}
                  />
                </IconButton>
              </Grid>
            </Paper>
            {filterDepartmentData.length > 0 &&
            filterSiteData.length > 0 &&
            filterActiveData.length > 0 ? (
              <Filter
                siteListData={filterSiteData}
                departmentListData={filterDepartmentData}
                activeListData={filterActiveData}
                handleRefreshClick={onRefreshClick}
              />
            ) : (
              <Grid style={homeButtonComponent} width={300}>
                <CircularProgress />
              </Grid>
            )}
          </Grid>
          {userList.length > 0 ? (
            <Grid>
              <UMTable
                rows={userList}
                orderHandler={handleOrderChange}
                OrderSortBy={selectedUserFilter}
                showTable={showTable}
                openEditUserModel={openEditUserClick}
              />
            </Grid>
          ) : (
            <Grid style={homeButtonComponent}>
              <Typography style={{ padding: '10px', fontWeight: 'bold' }}>
                {t('No_result_found')}
              </Typography>
            </Grid>
          )}
        </Grid>
      </Box>

      <MySavedViewModal
        openSaveModal={openSaveModal}
        onCloseModalClick={onCloseModalClick}
        errorMessage={errorMessage}
        setFilterName={setFilterName}
        getAllFilters={getAllFilters}
        setErrorMessage={setErrorMessage}
        onSaveModalClick={onSaveModalClick}
        filterName={filterName}
      />
      {isAddUserOpen && (
        <AddEditUserModal
          isUserModalOpen={isAddUserOpen}
          onSaveUserModalClick={onAddUserSaveClick}
          onCloseUserModalClick={onAddUserCloseClick}
          siteListData={siteListData}
          departmentListData={departmentListData}
          allusersEmail={allusersEmail}
        />
      )}
      {isEditUserOpen && (
        <AddEditUserModal
          isUserModalOpen={isEditUserOpen}
          onSaveUserModalClick={onEditUserSaveClick}
          onCloseUserModalClick={onEditUserCloseClick}
          addOrEdit="Edit"
          siteListData={siteListData}
          departmentListData={departmentListData}
          userDataForEdit={userDataForEdit}
        />
      )}
    </div>
  );
};

const mapStateToProps = (state = {}) => {
  return {
    userInfo: state.userInfo,
    errorInAPI: state.errorNotification,
  };
};

export default connect(mapStateToProps, null)(UserManagement);
